<template>
  <RouterLink
    class="font-semibold group text-gray-300 hover:text-white py-6 flex"
    :to="to"
  >
    <div class="mx-2">
      <slot />
    </div>
    <component :is="icon" />
  </RouterLink>
</template>

<script setup lang="ts">
import type { Component } from 'vue'

defineProps<{
  to: string
  icon?: Component,
}>()

</script>
